import { Empty } from '@nackle/paper';
import { MagnifierQuestion } from '@nackle/icons';
import * as React from 'react';
import { Component } from 'react';

export class NotFound extends Component {
    render() {
        return (
            <Empty
                image={<MagnifierQuestion/>}
                // title="Oops!"
                description="This path doesn't exist. Try using the links at the top of the page to get where you need to go."
            />
        );
    }
}
